<template>
	<div class="p-6">
		<h1 class="text-2xl font-semibold text-gray-900 mb-6">
			{{ __("Bank account details") }}
		</h1>
		<div class="grid grid-cols-1 gap-y-4 gap-x-6">
			<ui-input-group
				v-model="form.sepa.account_holder"
				field="sepa.account_holder"
				label="Bank account owner"
				:form="form"
				:required="false"
			></ui-input-group>

			<ui-input-group
				v-model="form.sepa.iban"
				field="sepa.iban"
				label="Bank account number (IBAN)"
				:form="form"
				:required="false"
			></ui-input-group>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
		form: {
			type: Object,
			required: true,
		},
	},
};
</script>
